@if (isLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div cdkDrag class="popup_main_div add_edit_allowance" cdkDragRootElement=".cdk-overlay-pane">
  <h2 cdkDragHandle mat-dialog-title class="mat-dialog-header">
    <span>Estate details</span>
    <button class="close-btn" mat-icon-button [mat-dialog-close]="false" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <div mat-dialog-content class="mat-typography main">
    <div class="one" fxLayout="column" fxLayoutAlign="start">
      <form name="form" fxLayout="column" fxLayoutAlign="start">
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field class="example pr-1" fxFlex="33" appearance="outline">
            <mat-label>Matter</mat-label>
            <input
              name="MatterName"
              readonly
              matInput
              [(ngModel)]="currentMatter.SHORTNAME"
              name="SHORTNAME"
            />
          </mat-form-field>
          <mat-form-field class="example pr-1" fxFlex="67" appearance="outline">
            <mat-label>Matter Discription</mat-label>
            <input
              name="MatterName"
              readonly
              matInput
              [(ngModel)]="currentMatter.CONTACTNAME"
              name="CONTACTNAME"
            />
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <div fxFlex="100">
            <app-wills-estate [action]="action" [moduleType]="moduleType"></app-wills-estate>
          </div>
        </div>
      </form>
    </div>
  </div>
  <mat-dialog-actions class="popup_ftr justify-end!">
    <button matButton="filled" [disabled]="isspiner" (click)="OnSubmit()" [disabled]="isspiner">
      @if (isspiner) {
        <mat-spinner diameter="24"></mat-spinner>
      }
      Update
    </button>
    <button matButton="tonal" [mat-dialog-close]="false" cdkFocusInitial>Don't Save</button>
  </mat-dialog-actions>
</div>
